import { motion } from "framer-motion";
import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { Reveal, MaskLine } from "./primitives";

export default function Contact() {
    return (
        <footer id="contact" data-testid="contact-section" className="bg-navy-deep text-white">
            <div className="blueprint-grid">
                <div className="mx-auto max-w-[1400px] px-5 pb-12 pt-24 sm:px-8 lg:pt-32">
                    <Reveal>
                        <div className="flex items-center gap-3">
                            <span className="h-[2px] w-8 bg-orange" />
                            <span className="text-[11px] font-semibold uppercase tracking-wide2 text-white/60">
                                Start A Conversation
                            </span>
                        </div>
                    </Reveal>

                    <h2 className="mt-8 font-display text-6xl font-bold uppercase leading-[0.92] tracking-mega md:text-8xl">
                        <MaskLine>Let's build</MaskLine>
                        <MaskLine delay={0.12}>
                            <span className="text-orange">what moves.</span>
                        </MaskLine>
                    </h2>

                    <div className="mt-16 grid grid-cols-1 gap-px bg-white/10 md:grid-cols-3">
                        <a
                            data-testid="contact-email-link"
                            href="mailto:admin@pawanputrainfra.com"
                            className="group bg-navy-deep p-8 transition-colors duration-300 hover:bg-navy"
                        >
                            <Mail className="h-6 w-6 text-orange" strokeWidth={1.5} />
                            <p className="mt-6 text-[11px] font-semibold uppercase tracking-wide2 text-white/50">
                                Email
                            </p>
                            <p className="mt-2 flex items-center gap-2 text-lg font-medium text-white">
                                admin@pawanputrainfra.com
                                <ArrowUpRight className="h-4 w-4 text-orange opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                            </p>
                        </a>
                        <a
                            data-testid="contact-phone-link"
                            href="tel:+919468564757"
                            className="group bg-navy-deep p-8 transition-colors duration-300 hover:bg-navy"
                        >
                            <Phone className="h-6 w-6 text-orange" strokeWidth={1.5} />
                            <p className="mt-6 text-[11px] font-semibold uppercase tracking-wide2 text-white/50">
                                Phone
                            </p>
                            <p className="mt-2 flex items-center gap-2 text-lg font-medium text-white">
                                +91 94685 64757
                                <ArrowUpRight className="h-4 w-4 text-orange opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
                            </p>
                        </a>
                        <div data-testid="contact-address" className="bg-navy-deep p-8">
                            <MapPin className="h-6 w-6 text-orange" strokeWidth={1.5} />
                            <p className="mt-6 text-[11px] font-semibold uppercase tracking-wide2 text-white/50">
                                Head Office
                            </p>
                            <p className="mt-2 text-lg font-medium text-white">Jodhpur, Rajasthan, India</p>
                        </div>
                    </div>

                    <div className="mt-16 flex flex-col items-start justify-between gap-8 border-t border-white/10 pt-10 md:flex-row md:items-center">
                        <div className="flex items-center gap-4">
                            <div className="flex h-14 items-center bg-white px-3">
                                <img src="/logo.png" alt="Pawan Putra Infra logo" className="h-11 w-auto object-contain" />
                            </div>
                            <p className="text-xs leading-relaxed text-white/50">
                                Pawan Putra Infra
                                <br />
                                Railway Civil Works & Infrastructure
                            </p>
                        </div>
                        <motion.p
                            initial={{ opacity: 0 }}
                            whileInView={{ opacity: 1 }}
                            viewport={{ once: true }}
                            className="font-display text-sm uppercase tracking-[0.2em] text-white/40"
                        >
                            Jodhpur — Rajasthan — India
                        </motion.p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
